import { Injectable, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ToasterUtilService } from '../util/toaster-util.service';
import { SessaoUtil } from '../util/sessao-util';
import { UtilService } from '../util/util.service';
import { Router } from '@angular/router';
import { RetornoValidacaoModel } from '../util/model/retorno-validacao.model';
import { TipoAlerta } from '../util/enum/tipo-alerta.enum';


@Injectable()
export class GenericService<T> {
  // URL padrao sistema
  private url: string = UtilService.getUrl();
  // Variaveis
  private headers: Headers;

  constructor(
    protected http: Http,
    protected sessaoUtil: SessaoUtil,
    protected toasterUtil: ToasterUtilService,
    protected router: Router,
    protected injector: Injector,
    private pathUrl: string) {
      this.router = this.injector.get(Router);
  }

  getUrl() : string{
    return this.url + this.pathUrl;
  }

  getHeaders(): Headers {
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    //this.headers.append('Access-Control-Allow-Origin', 'Content-Type');
    this.headers.append('Authorization', 'Bearer ' + this.sessaoUtil.getToken().access_token);
    return this.headers;
  }

  findById(id: number): Promise<T> {

    return this.http.get(this.getUrl() + "/" + id, { headers: this.getHeaders()})
      .toPromise()
      .then((response: Response) => {
        this.handleMessage(response.headers);
        return <T>response.json();
      })
      .catch(this.handleErrorRetornoValidacao.bind(this));
  }

  findByAll(): Promise<T[]> {

    return this.http.get(this.getUrl(), { headers: this.getHeaders()})
      .toPromise()
      .then((response: Response) => {
        this.handleMessage(response.headers);
        return <T[]>response.json();
      })
      .catch(this.handleErrorRetornoValidacao.bind(this));
  }

  excluiById(id: number): Promise<boolean> {

    return this.http.delete(this.getUrl() + "/" + id, { headers: this.getHeaders() })
      .toPromise()
      .then((response: Response) => {
        this.handleMessage(response.headers);
        return (response.status === 204);
      })
      .catch(this.handleErrorRetornoValidacao.bind(this));
  }

  inclui(t: T): Promise<boolean> {

    let tJSON = JSON.stringify(t);

    return this.http.post(this.getUrl(), tJSON, { headers: this.getHeaders() })
      .toPromise()
      .then((response: Response)  => {
        //this.handleMessage(response.headers);
        //if (response instanceof Response) {this.handleValidator(response);}
        return (response.status === 201);
      })
      .catch(this.handleErrorRetornoValidacao.bind(this));
  }

  altera(t: T): Promise<boolean> {

    let tJSON = JSON.stringify(t);

    return this.http.put(this.getUrl(), tJSON, { headers: this.getHeaders() })
      .toPromise()
      .then((response: Response)  => {
        //this.handleMessage(response.headers);
        return (response.status === 204);
      })
      .catch(this.handleErrorRetornoValidacao.bind(this));
  }

  atualizaAtivo(id: number, value: boolean): Promise<boolean> {

    return this.http.post(this.getUrl() + '/atualizaAtivo/' + id + '/' + value, null, { headers: this.getHeaders() })
      .toPromise()
      .then((response: Response)  => {
        this.handleMessage(response.headers);
        return response.json();
      }).catch(error => {
        this.handleErrorRetornoValidacao(error);
        return Promise.reject(error); // Re-lançar a exceção
      });
  }

  buscaCep($cep) : Promise<any> {
    //retorna endereço a partir do cep
    let cepSemMascara = $cep.replace('.', '');
    return this.http.get('http://api.postmon.com.br/cep/' + cepSemMascara)
      .toPromise()
      .then((response : Response) =>{
        return response.json();
      }).catch((erro) => this.toasterUtil.alerta('O CEP informado não existe ou está incorreto.'));
    //);
  }

  protected handleError(error: any): Promise<any> {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.messages || JSON.stringify(body);
      const msgErro = UtilService.stringNotNull(body.error_description);

      if(msgErro.length > 19 && msgErro.substring(0,20).toLowerCase() == "access token expired"){
        this.sessaoUtil.limpaDadosSessao();
        this.router.navigate(['/login']);
      }else if(body.error != undefined && body.error == "invalid_grant"){
        errMsg = 'Login/E-Mail ou senha inválidos.';
        return null;
      }else{
        errMsg = `${err}`;
      }
    } else {
      errMsg = error.messages ? error.messages : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }

  protected handleErrorRetornoValidacao(error: any): void {
    let errMsg: string;
    if (error instanceof Response) {
      const retorno : RetornoValidacaoModel = error.json() || '';

      UtilService.processaRetornoValidator(retorno, this.toasterUtil);

    } else {
        const body = error.json() || '';
        const err = body.messages || JSON.stringify(body);
        const msgErro = UtilService.stringNotNull(body.error_description);

        if(msgErro.length > 19 && msgErro.substring(0,20).toLowerCase() == "access token expired"){
          this.toasterUtil.erro('Sessão expirada.');
          this.sessaoUtil.limpaDadosSessao();
          this.router.navigate(['/login']);
        }else if(body.error != undefined && body.error == "invalid_grant"){
          errMsg = 'Login/E-Mail ou senha inválidos.';
        }else{
          errMsg = `${err}`;
          this.toasterUtil.erro(errMsg);
        }
    }
  }

  protected handleMessage(header: Headers) {
    if (header == null || header == undefined) {
      return;
    }
    let emissorMessage = header.toJSON();
    if (emissorMessage != undefined && emissorMessage != null) {
      let arrayMessage = emissorMessage['MessageEmissorNF'] || emissorMessage['messageemissornf'];
      if (arrayMessage != null && arrayMessage != undefined && arrayMessage.length > 0) {
        let causaString = arrayMessage[0];
        let causaJSON = decodeURIComponent(causaString);
        let causaArray = JSON.parse(causaJSON);
        for(let i = 0; i < causaArray.length; i++) {
          if (causaArray[i].tipo == 'INFO') {
            this.toasterUtil.info(causaArray[i].msg);
          }
          if (causaArray[i].tipo == 'WARN') {
            this.toasterUtil.alerta(causaArray[i].msg);
          }
          if (causaArray[i].tipo == 'ERRO' || causaArray[i].tipo == 'FATAL') {
            this.toasterUtil.erro(causaArray[i].msg);
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/generic.service.ts